<template lang="pug">
.reading-list(:class="{ open: readingListOpen, framed }",
              v-if="!cheatsheetLP && !watchlist",
              @mouseleave="autoHide",
              @mouseenter="cancelAutoHide",
              @dragover.prevent="readingListOpen = true",
              :title="!readingListOpen && 'Open reading list' || ''",
              @click="readingListOpen = true")
  .menu
    a.url(v-if="license", target="_blank", :href="`https://${ license }`") {{ license.replace(/rebrand.ly\//, '') }}
    .share(v-else, @click="shortenUrl") share
    //span(v-else, style="opacity: 0") wq-AAA-000
  .wrap(:style="{ opacity: hovered && 1 || 0 }")
    .info(:style="{ transform: hovered && `translate3d(0, ${ hovered.top }px, 0` }")
      .source-image(:style="{ 'background-image': hovered && hovered.simgu && `url('${ hovered.simgu }')` }")
      .title {{ hovered && hovered.t }}
      .published {{ hovered && hovered.pgc }} page{{ hovered && hovered.pgc !== 1 && 's' || '' }}&nbsp;
        .soft  published on&nbsp;
        |  {{ hovered && prettyDate(hovered.dpa) || '' }}
        .soft &nbsp;by&nbsp;
        | {{ hovered && hovered.st }}
  .items
    .item(v-for="(id, index) in readingList",
          :id="id",
          :ref="`rl|${ id }`",
          :class="{ selected: id === doco, 'drop-target': id === dropBefore, heading: isHeading(id) }",
          kind="document",
          :draggable="doco",
          @dragstart="start",
          @dragover.prevent="isHeading(id) && (() => 1) || over(id)",
          @drop.prevent="drop",
          @mouseenter="hover(id)",
          @mouseleave="hover(id, true)",
          :style="{ 'background-image': !isHeading(id) && `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ id }-1.png')` || '' }",
          @dblclick.stop="editingReadingList = true",
          @click.stop="isHeading(id) && (() => 1) || loadDoco(id, index)")
            label(v-if="isHeading(id) && editingReadingList"
                  @dblclick.stop="editingReadingList = false")
              input(:value="formatHeading(id)",
                    @blur="saveHeading",
                    @focus="editingReadingList = id",
                    @keyup.enter="saveHeading")
            .inner(v-else) {{ isHeading(id) && formatHeading(id) || '\u00a0' }}
  .close(@click.stop="readingListOpen = false", title="Close reading list")
  .count(v-if="readingList && readingList.length") {{ readingList && readingList.filter(id => /^[^\|]/.test(id)).length }}
</template>
<script>
import { mapGetters } from 'vuex';
import { vuexComputed, licensePlate, prettyDate } from '@/helpers';
let timer;
let timer2;
export default {
  name: 'readingList',
  computed: {
    ...mapGetters(['doco', 'framed', 'docoSmallCache', 'readingListHoveredItem', 'cheatsheetLP', 'watchlist']),
    ...vuexComputed(
      'readingListOpen',
      'readingListIndex',
      'dropBefore',
      'readingList',
      'editingReadingList',
      'license',
      'licenseUrl',
      'readingListHoveredItem',
      'dragType'
    ),
    hovered() {
      return this.readingListHoveredItem;
    }
  },
  methods: {
    licensePlate,
    prettyDate,
    async loadDoco(id, index) {
      const {
        dispatch,
        getters: { docSort }
      } = this.$store;
      await dispatch('loadDoco', id);
      await (this.readingListIndex = index);
      await dispatch('docSort', docSort);
    },
    meta(did) {
      return this.docoSmallCache[did];
    },
    hover(did, hide) {
      const { editingReadingList, readingListOpen, meta, $refs } = this;
      clearTimeout(timer2);
      if (hide || editingReadingList) {
        timer2 = setTimeout(() => (this.readingListHoveredItem = null), 500);
      } else if (readingListOpen) {
        const doc = meta(did);
        const { top } = $refs[`rl|${ did }`]?.[0].getBoundingClientRect() || {};
        // console.log('hover', did, top, $refs);
        // 20 likely the offsetTop of the reading list
        this.readingListHoveredItem = (doc && { ...doc, top: top - 20 }) || null;
      }
    },
    autoHide() {
      clearTimeout(timer);
      timer = setTimeout(() => (this.readingListOpen = false), 2500);
    },
    cancelAutoHide() {
      clearTimeout(timer);
    },
    start({ dataTransfer, target: { id }, target }) {
      dataTransfer.setData('text/plain', id);
      this.editingReadingList = false;
      this.dragType = target.getAttribute('kind');
    },
    over(id) {
      // if (this.dragType === 'document') {
      this.dropBefore = id;
      // }
    },
    drop({ dataTransfer }) {
      const id = dataTransfer.getData('text/plain');
      const { dropBefore, readingList, doco } = this;
      this.dropBefore = null;
      // const from = readingList.indexOf(id);
      if (dropBefore) {
        const from = readingList.indexOf(id);
        const to = readingList.indexOf(dropBefore);
        //console.log('drop', id, from, to);
        if (from === -1) {
          //console.log('external window', id);
          readingList.splice(to, 0, id);
        } else {
          readingList.splice(to, 0, readingList.splice(from, 1)[0]);
        }
        //this.readingList = this.readingList.splice()
        this.readingList = readingList;
        this.readingListIndex = readingList.indexOf(doco);
        console.log('success');
      } else {
        console.log('no drop before');
      }
    },
    isHeading(id) {
      return /^\|/.test(id);
    },
    formatHeading(id) {
      return decodeURIComponent(id.replace(/^\||\|$/g, ''));
    },
    async saveHeading({ target: { value } }) {
      const { readingList, editingReadingList: id } = this;
      const index = readingList.indexOf(id);
      //console.log('saveHeading', index, id, value, readingList);
      //todo: ensure uniqueness of heading
      if (id && readingList && value?.trim().length) {
        await this.readingList.splice(index, 1, `|${ encodeURIComponent(value) }|`);
        await (this.readingList = this.readingList);
        this.editingReadingList = null;
      }
    },
    async shortenUrl() {
      try {
        const r = await fetch('https://api.rebrandly.com/v1/links', {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify({
            destination: location.href.replace(/localhost\:\d\d\d\d/, 'analyst.weave.ai'),
            slashtag: `wq${ this.licensePlate() }`
          }),
          headers: {
            'Content-Type': 'application/json',
            apikey: 'deb84475e664435dae8e796676115fee'
          },
          redirect: 'follow'
        });
        const j = await r.json();
        const { shortUrl, destination } = j || {};
        if (shortUrl) {
          this.license = shortUrl;
          this.licenseUrl = destination;
          console.log('success', this.license, this.licenseUrl);
        }
      } catch (e) {
        console.log('no luck', e);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.reading-list {
  position: fixed;
  right: 1rem;
  top: 1rem;
  background-color: white;
  box-shadow: 1px 1px 3px black;
  border-radius: 0.25rem;
  transform: translate3d(-1rem, -0.25rem, 0) scale(0.66);
  transform-origin: top right;
  padding: 0 !important;
  cursor: pointer;
  &.framed {
    right: 3rem !important;
  }
  &.open {
    cursor: default;
    transform: none;
    padding: 1rem !important;
    .menu {
      display: flex;
      justify-content: space-around;
    }
    .info {
      //opacity: 1;
    }
    .items {
      pointer-events: all;
      grid-template-columns: repeat(5, 20%);
      overflow: auto;
      max-height: 90vh;
      .item {
        display: block;
        width: 6rem;
        margin: 0.25rem;
        position: relative;
        &.selected {
          pointer-events: all;
          box-shadow: 1px 1px 5px black;
        }
        &.heading {
          grid-column-start: 1;
          grid-column-end: 6;
          width: 100%;
          box-sizing: border-box;
          border: 1px solid #efefef;
          border-bottom-color: $brn;
          border-bottom-width: 2px;
          outline: none;
          padding-top: 0;
          margin: 1.5rem 0 0.25rem;
          font-weight: 500;
          //color: white;
          color: $brn;
          font-size: 2rem;
          /*text-shadow: 0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn;*/
          -webkit-font-smoothing: antialiased;
          input {
            width: 100%;
            // height: 2rem;
            font-weight: 250;
            font-size: 2rem;
            text-align: center;
            color: $brn;
            outline: none;
            border: none;
          }
        }
      }
    }
    .close {
      pointer-events: all;
      display: block;
    }
    .count {
      display: none;
    }
  }
  .wrap {
    position: absolute;
    // top: 1rem;
    top: 0;
    right: calc(100% - 2px);
    will-change: opacity;
    transition: opacity 300ms ease-in-out 100ms;
    .info {
      position: relative;
      pointer-events: none;
      // right: 105%;
      z-index: 3;
      //opacity: 0;
      min-width: 20vw;
      background-color: white;
      padding: 0.25rem 0.5rem;
      padding-left: 2.5rem;
      border: 1px solid $brn;
      border-right: 3px solid white;
      border-radius: 3px;
      box-shadow: -2px 1px 3px #ccc;
      will-change: transform;
      transition: transform 300ms ease-in-out 50ms;
      .source-image {
        position: absolute;
        left: 0.25rem;
        top: 0.25rem;
        width: 2rem;
        height: 2rem;
        background: no-repeat center;
        background-size: contain;
      }
      .title,
      .published {
        text-align: right;
        white-space: nowrap;
        margin: 0.25rem;
      }
      .title {
        font-size: 1.4rem;
        font-weight: 200;
      }
      .published {
        font-weight: 400;
        display: flex;
        justify-content: flex-end;
        .soft {
          opacity: 0.7;
          font-weight: 200;
        }
      }
    }
  }
  .menu {
    position: relative;
    top: -0.5rem;
    display: none;
    .share {
      cursor: pointer;
      color: $brn;
      padding: 0.125rem 0.25rem 0.125rem 1.5rem;
      background-position: left center;
      border: 1px solid $brn;
      border-radius: 3px;
    }
    a.url {
      text-decoration: none;
      color: $brn;
      padding: 0.125rem 0.25rem;
      display: inline-block;
    }
  }
  .count {
    position: absolute;
    top: 0;
    left: 100%;
    transform: translate3d(0.5rem, 0, 0);
  }
  .close {
    display: none;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    height: 3rem;
    width: 3rem;
    &:hover {
      &::after {
        color: black;
      }
    }
    &::after {
      color: #dadada;
      cursor: pointer;
      content: '\00d7';
      position: absolute;
      top: -0.3rem;
      right: -0rem;
      font-size: 1.25rem;
      //margin-top: -0.05rem;
      //transform: translate3d(0, -70%, 0);
    }
  }
  .items {
    display: grid;
    //grid-template-columns: repeat(5, 20%);
    grid-template-columns: 100%;
    .item {
      display: none;
      width: 3rem;
      padding-top: 100%;
      background: no-repeat center;
      background-size: contain;
      background-color: white;
      outline: 2px solid #dadada;
      position: relative;
      //box-shadow: 1px 1px 3px black;
      cursor: pointer;
      //outline: 1px solid black;
      transition: transform 250ms ease-in-out;
      will-change: transform;
      &.drop-target {
        transform: translate3d(1.5rem, 0, 0);
        &::before {
          content: '\00a0';
          position: absolute;
          top: 0;
          left: -1rem;
          height: 100%;
          width: 0.25rem;
          background-color: $brn;
        }
      }
      &.selected {
        pointer-events: none;
        display: block;
        outline: 2px solid orange;
        /*box-shadow: 1px 1px 3px black,
                    1px 1px 6px black,
                    1px 1px 9px black;*/
      }
    }
  }
}
</style>
